<template>
  <div>
    <!-- <LinkookLiveBanner :class="$style.linkookLiveBanner" /> -->
    <div :class="$style.container">
      <!-- <div :class="$style.header">
      <h1 :class="$style.title">아티스트 목록</h1>
      <p :class="$style.subtitle">등록된 아티스트들을 확인해보세요</p>
    </div> -->

      <!-- 배너 -->

      <!-- 에러 상태 -->
      <div v-if="error" :class="$style.error">
        <p>{{ error }}</p>
        <button @click="fetchArtists" :class="$style.retryButton">
          다시 시도
        </button>
      </div>

      <!-- 아티스트 데이터 -->
      <div v-else>
        <!-- 검색 및 필터 -->
        <div :class="$style.controls">
          <!-- 악기 필터 -->
          <div :class="$style.typeFilter">
            <!-- 타입 전체 보기 드롭다운 (햄버거) - 스크롤 영역 밖에 두어 잘리지 않게 -->
            <div :class="$style.typeDropdown" ref="typeDropdownContainer">
              <button :class="$style.dropdownToggle" @click.stop="toggleTypeDropdown">
                <img src="@/assets/images/dehaze.png" alt="타입 필터 메뉴" :class="$style.dehazeIcon" />
              </button>
              <div v-if="showTypeDropdown" :class="$style.dropdownMenu">
                <button v-for="opt in artistTypeFilterOptions" :key="opt.key" :class="[
                  $style.dropdownItem,
                  { [$style.activeDropdownItem]: getActiveArtistListTypeKey(selectedTypes) === opt.key },
                ]" @click="selectTypeFromDropdown(opt.key)">
                  {{ opt.label }}
                </button>
              </div>
            </div>
            <div ref="typeFilterScroll" :class="$style.typeFilterScroll">
              <button :class="[
                $style.likeButton,
                { [$style.activeLike]: showLikedOnly },
              ]" @click="toggleLikedFilter">
                <img :class="$style.likeIcon" src="@/assets/images/heart.png" />
              </button>
              <button v-for="opt in artistTypeFilterOptions" :key="opt.key" :data-type-key="opt.key" :class="[
                $style.typeButton,
                { [$style.activeType]: selectedTypes[opt.key] },
              ]" @click="toggleType(opt.key)">
                {{ opt.label }}
              </button>
              <button v-if="!userStore.isBlocked" :class="[$style.registerButton, $style.desktopOnly]"
                @click="openArtistForm">
                <img :class="$style.plusIcon" src="@/assets/images/plus.svg" alt="추가" />
                아티스트 등록 신청
              </button>
            </div>
          </div>

          <!-- 정렬 버튼 -->
          <div :class="$style.sortFilter">
            <div :class="$style.searchBox">
              <input v-model="searchQuery" type="text" placeholder="아티스트명 검색" :class="$style.searchInput" />
            </div>

            <div :class="$style.filterBox">
              <button @click="toggleSort" :class="[$style.sortButton, $style.toggleSortButton]">
                {{ getSortButtonText() }}
                <img :class="$style.sortIcon" src="@/assets/images/swap_vert.png" alt="정렬 변경" />
              </button>
            </div>
          </div>

          <!-- <div :class="$style.filterBox">
          <select v-model="sortBy" :class="$style.sortSelect">
            <option value="name">이름순</option>
            <option value="updated">최근 업데이트순</option>
            <option value="profile">프로필 사진 유무</option>
            <option value="detail">상세 정보 유무</option>
            <option value="liked">찜한 순</option>
          </select>
        </div> -->
        </div>

        <!-- 로딩 상태 -->
        <div v-if="loading" :class="$style.loading">
          <div :class="$style.spinner"></div>
          <p>아티스트 정보를 불러오는 중...</p>
        </div>

        <!-- 아티스트 목록 -->
        <div v-else :class="$style.artistList">
          <!-- 내 아티스트 카드가 없을 때 등록 유도 카드 (비로그인도 표시) -->
          <div v-if="(!userStore.isLogin || !hasMyArtistCard) && currentPage === 1" :class="$style.emptyArtistCard"
            @click="openArtistCardModal">
            <div :class="$style.emptyCardGlow"></div>
            <div :class="$style.emptyCardContent">
              <div :class="$style.emptyProfileCircle">
                <div :class="$style.plusIcon">+</div>
              </div>
              <div :class="$style.emptyCardText">
                <h3 :class="$style.emptyCardTitle">내 아티스트 카드 만들기</h3>
                <p :class="$style.emptyCardSubtitle">
                  지금 바로 나만의 아티스트 카드를 등록해보세요!
                </p>
                <div :class="$style.emptyCardBadge">
                  👑 특별한 골드 테두리로 표시됩니다
                </div>
              </div>
            </div>
          </div>

          <ArtistCard v-for="artist in paginatedArtists" :key="artist.name" :artist="artist"
            :is-liked="isArtistLiked(artist.id)" :show-like-button="true" :disabled="likeLoading"
            :is-my-card="isMyArtist(artist)" @like-toggle="toggleArtistLike" />
        </div>
        <p v-if="!loading" :class="$style.adminNotice">
          ♥ 게시판에서 아티스트 정보 수정 권한 신청 가능합니다 ♥
        </p>

        <!-- 페이지네이션 -->
        <div v-if="!loading && totalPages > 1" :class="$style.pagination">
          <button :class="$style.pageButton" @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
            ‹
          </button>

          <button v-for="page in pageRange" :key="page" :class="[
            $style.pageButton,
            { [$style.activePage]: page === currentPage },
          ]" @click="goToPage(page)">
            {{ page }}
          </button>

          <button :class="$style.pageButton" @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">
            ›
          </button>
        </div>
      </div>
    </div>

    <!-- 모바일 플로팅 등록 버튼 -->
    <button v-if="!userStore.isBlocked" :class="[$style.floatingButton, $style.mobileOnly]" @click="openArtistForm">
      <span :class="$style.floatingText">+ 신규등록</span>
    </button>

    <!-- 아티스트 등록 폼 -->
    <artist-form :is-visible="showArtistForm" mode="create" @close-popup="closeArtistForm" />

    <!-- 아티스트 카드 모달 -->
    <ArtistCardModal :isVisible="artistCardModalVisible" :userDetailLink="userDetailLink" :userStore="userStore"
      @close="closeArtistCardModal" @artist-card-updated="handleArtistCardUpdated" />
  </div>
</template>

<script>
import {
  collection,
  getDocs
} from "firebase/firestore";
import { ref as storageRef, getDownloadURL } from "firebase/storage";
import { firestore, storage } from "/firebaseConfig";
import { useUserStore } from "@/store/user";
import ArtistCard from "@/components/ArtistCard.vue";
import ArtistForm from "@/components/modal/form/ArtistForm.vue";
import ArtistCardModal from "@/components/modal/ArtistCardModal.vue";
import scrollManager from "@/utils/scrollManager";
// import LinkookLiveBanner from "@/components/layout/LinkookLiveBanner.vue";
import { toggleArtistLike } from "@/utils/write/user";
import { createNotification } from "@/utils/write/alarm";
import { parse, isValid } from "date-fns";
import {
  ARTIST_LIST_FILTER_OPTIONS,
  createArtistListSelectedTypes,
  getActiveArtistListTypeKey,
} from "@/utils/artistTypes";

export default {
  name: "ArtistList",
  components: {
    ArtistCard,
    ArtistForm,
    ArtistCardModal,
    // LinkookLiveBanner,
  },
  data() {
    return {
      artists: [],
      loading: true,
      error: null,
      searchQuery: "",
      sortBy: "popular",
      currentPage: 1,
      itemsPerPage: 12,
      showLikedOnly: false,
      likeLoading: false,
      userArtistLikes: [], // Firestore에서 가져온 찜한 아티스트 목록
      showArtistForm: false, // 아티스트 등록 폼 표시 여부
      artistCardModalVisible: false, // 아티스트 카드 모달 표시 여부
      userDetailLink: null, // 사용자의 트위터 링크
      selectedTypes: createArtistListSelectedTypes(),
      showTypeDropdown: false, // 타입 필터 햄버거 드롭다운 열림 여부
    };
  },
  computed: {
    userStore() {
      return useUserStore();
    },
    artistTypeFilterOptions() {
      return ARTIST_LIST_FILTER_OPTIONS;
    },
    hasMyArtistCard() {
      if (!this.userStore.isLogin || !this.userStore.email) {
        return false;
      }
      return this.artists.some(
        (artist) => artist.userEmail === this.userStore.email
      );
    },
    filteredArtists() {
      let filtered = [...this.artists];

      // 검색 필터
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        filtered = filtered.filter((artist) =>
          artist.name && artist.name.toLowerCase().includes(query)
        );
      }

      // 찜한 아티스트 필터
      if (this.showLikedOnly) {
        filtered = filtered.filter((artist) => this.isArtistLiked(artist.id));
      }

      // 악기 필터 (배열 구조 지원)
      if (!this.selectedTypes.all) {
        const activeTypeKey = getActiveArtistListTypeKey(this.selectedTypes);
        filtered = filtered.filter((artist) => {
          if (!artist.type) return false;

          // type이 배열인 경우와 문자열인 경우 모두 처리
          const types = Array.isArray(artist.type)
            ? artist.type
            : [artist.type];

          return types.includes(activeTypeKey);
        });
      }

      // 정렬
      switch (this.sortBy) {
        case "performance":
          filtered.sort((a, b) => (b.liveCount || 0) - (a.liveCount || 0));
          break;
        case "popular":
          filtered.sort((a, b) => (b.likeCount || 0) - (a.likeCount || 0));
          break;
        case "name":
          filtered.sort((a, b) => a.name.localeCompare(b.name));
          break;
        case "recent":
          filtered.sort((a, b) => {
            // 가장 가까운 공연이 있는 아티스트가 먼저 오도록
            if (a.lastPerformanceDate && !b.lastPerformanceDate) return -1;
            if (!a.lastPerformanceDate && b.lastPerformanceDate) return 1;
            if (!a.lastPerformanceDate && !b.lastPerformanceDate) {
              // 둘 다 공연이 없으면 이름순
              return a.name.localeCompare(b.name);
            }

            // LinkookLiveTiles와 동일한 방식으로 날짜 처리
            const getDateOnly = (date) => {
              return new Date(date.getFullYear(), date.getMonth(), date.getDate());
            };

            // Date 객체 변환을 안전하게 처리
            let aDate = null;
            let bDate = null;

            if (a.lastPerformanceDate) {
              if (a.lastPerformanceDate instanceof Date) {
                aDate = a.lastPerformanceDate;
              } else if (a.lastPerformanceDate.seconds) {
                aDate = new Date(a.lastPerformanceDate.seconds * 1000);
              } else if (a.lastPerformanceDate.toDate) {
                aDate = a.lastPerformanceDate.toDate();
              } else {
                aDate = new Date(a.lastPerformanceDate);
              }
              // 유효하지 않은 날짜인 경우 null로 설정
              if (!isValid(aDate)) {
                aDate = null;
              }
            }

            if (b.lastPerformanceDate) {
              if (b.lastPerformanceDate instanceof Date) {
                bDate = b.lastPerformanceDate;
              } else if (b.lastPerformanceDate.seconds) {
                bDate = new Date(b.lastPerformanceDate.seconds * 1000);
              } else if (b.lastPerformanceDate.toDate) {
                bDate = b.lastPerformanceDate.toDate();
              } else {
                bDate = new Date(b.lastPerformanceDate);
              }
              // 유효하지 않은 날짜인 경우 null로 설정
              if (!isValid(bDate)) {
                bDate = null;
              }
            }

            if (!aDate) return 1;
            if (!bDate) return -1;

            // 날짜 부분만 비교 (시간 제외) - LinkookLiveTiles 방식
            const dateOnlyA = getDateOnly(aDate);
            const dateOnlyB = getDateOnly(bDate);

            // 오늘 날짜와의 거리 계산 (LinkookLiveTiles 방식)
            const today = new Date();
            const todayMidnight = new Date(
              today.getFullYear(),
              today.getMonth(),
              today.getDate()
            );

            const aDistance = Math.abs(dateOnlyA.getTime() - todayMidnight.getTime());
            const bDistance = Math.abs(dateOnlyB.getTime() - todayMidnight.getTime());

            return aDistance - bDistance;
          });
          break;
        case "updated":
          filtered.sort(
            (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
          );
          break;
        case "profile":
          filtered.sort((a, b) => {
            if (a.profileImage && !b.profileImage) return -1;
            if (!a.profileImage && b.profileImage) return 1;
            return a.name.localeCompare(b.name);
          });
          break;
        case "detail":
          filtered.sort((a, b) => {
            if (a.detailLink && !b.detailLink) return -1;
            if (!a.detailLink && b.detailLink) return 1;
            return a.name.localeCompare(b.name);
          });
          break;
        case "liked":
          filtered.sort((a, b) => {
            const aLiked = this.isArtistLiked(a.id);
            const bLiked = this.isArtistLiked(b.id);
            if (aLiked && !bLiked) return -1;
            if (!aLiked && bLiked) return 1;
            return a.name.localeCompare(b.name);
          });
          break;
        case "registered":
          filtered.sort((a, b) => {
            // 등록일시가 최신인 것이 먼저 오도록 (내림차순)
            let aDate = new Date(0);
            let bDate = new Date(0);

            if (a.createdAt) {
              if (a.createdAt.seconds) {
                // Firestore Timestamp 객체인 경우
                aDate = new Date(a.createdAt.seconds * 1000);
              } else if (a.createdAt.toDate) {
                // toDate 메서드가 있는 경우
                aDate = a.createdAt.toDate();
              } else {
                // 일반 날짜 문자열이나 Date 객체인 경우
                aDate = new Date(a.createdAt);
              }
            }

            if (b.createdAt) {
              if (b.createdAt.seconds) {
                bDate = new Date(b.createdAt.seconds * 1000);
              } else if (b.createdAt.toDate) {
                bDate = b.createdAt.toDate();
              } else {
                bDate = new Date(b.createdAt);
              }
            }

            return bDate - aDate; // 최신순 (내림차순)
          });
          break;
      }

      // 본인 아티스트를 최상단으로 이동
      if (this.userStore.isLogin && this.userStore.email) {
        const myArtistIndex = filtered.findIndex(
          (artist) => artist.userEmail === this.userStore.email
        );

        if (myArtistIndex > 0) {
          // 본인 아티스트를 찾았고 첫 번째가 아닌 경우
          const myArtist = filtered.splice(myArtistIndex, 1)[0];
          filtered.unshift(myArtist);
        }
      }

      return filtered;
    },
    paginatedArtists() {
      if (!this.hasMyArtistCard) {
        const start = (this.currentPage - 1) * this.itemsPerPage - (this.currentPage === 1 ? 0 : 1);
        const end = start + this.itemsPerPage - (this.currentPage === 1 ? 1 : 0);
        return this.filteredArtists.slice(start, end);
      } else {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.filteredArtists.slice(start, end);
      }
    },
    totalPages() {
      return Math.ceil(this.filteredArtists.length / this.itemsPerPage);
    },
    pageRange() {
      const total = this.totalPages;
      const current = this.currentPage;

      if (total <= 5) {
        const pages = [];
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
        return pages;
      }

      let start, end;

      if (current <= 3) {
        start = 1;
        end = 5;
      } else if (current >= total - 2) {
        start = total - 4;
        end = total;
      } else {
        start = current - 2;
        end = current + 2;
      }

      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
    totalArtists() {
      return this.artists.length;
    },
    artistsWithProfile() {
      return this.artists.filter((artist) => artist.profileImage).length;
    },
    artistsWithDetail() {
      return this.artists.filter((artist) => artist.detailLink).length;
    },
  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
      this.$nextTick(() => {
        this.loadProfileImagesForCurrentPage();
      });
    },
    sortBy() {
      this.currentPage = 1;
      this.$nextTick(() => {
        this.loadProfileImagesForCurrentPage();
      });
    },
    showLikedOnly() {
      this.currentPage = 1;
      this.$nextTick(() => {
        this.loadProfileImagesForCurrentPage();
      });
    },
    selectedTypes: {
      handler() {
        this.currentPage = 1;
        this.$nextTick(() => {
          this.loadProfileImagesForCurrentPage();
          this.scrollActiveTypeIntoView();
        });
      },
      deep: true,
    },
    currentPage() {
      // 페이지 변경 시 해당 페이지의 이미지 로드
      this.loadProfileImagesForCurrentPage();
    },
  },
  async mounted() {
    await this.loadUserLikes();
    await this.loadUserDetailLink();
    await this.fetchArtists();
    document.addEventListener("click", this.handleTypeDropdownClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleTypeDropdownClickOutside);
  },
  methods: {
    async loadUserLikes() {
      if (!this.userStore.isLogin) {
        return;
      }

      try {
        // API를 통해 사용자 데이터 가져오기
        const { getUserLikes } = await import("@/utils/read/user");
        const userLikes = await getUserLikes(this.userStore.email);
        this.userArtistLikes = userLikes.artistLikes || [];
      } catch (error) {
        console.error("사용자 찜 데이터 로드 오류:", error);
        this.userArtistLikes = [];
      }
    },

    async fetchArtists() {
      try {
        this.loading = true;
        this.error = null;

        // artists와 lives 컬렉션을 병렬로 가져오기
        const [artistsSnapshot, livesSnapshot] = await Promise.all([
          getDocs(collection(firestore, "artists")),
          getDocs(collection(firestore, "lives")),
        ]);

        // 아티스트 ID-이름 매핑 생성
        const artistIdToNameMap = new Map(); // ID -> 이름
        const artistNameToIdMap = new Map(); // 이름 -> ID

        artistsSnapshot.docs.forEach((doc) => {
          const artistData = doc.data();
          artistIdToNameMap.set(doc.id, artistData.name);
          artistNameToIdMap.set(artistData.name, doc.id);
        });

        // 밴드-멤버 관계 매핑 생성 (공연 횟수 계산용)
        const bandMemberMap = new Map(); // 밴드명 -> 멤버 ID 배열

        artistsSnapshot.docs.forEach((doc) => {
          const artistData = doc.data();
          // 밴드 타입인지 확인 (배열 구조 지원)
          const types = Array.isArray(artistData.type)
            ? artistData.type
            : [artistData.type];
          if (
            types.includes("band") &&
            artistData.approved &&
            artistData.members
          ) {
            const bandName = artistData.name;
            const memberIds = artistData.members || []; // ID 배열
            bandMemberMap.set(bandName, memberIds);
          }
        });

        // 각 아티스트별 공연 횟수 및 가장 가까운 공연 날짜 계산 (승인된 공연만, 소속 밴드 공연 포함)
        const artistLiveCount = new Map();
        const artistPerformances = new Map(); // 모든 공연 날짜 저장

        livesSnapshot.docs.forEach((doc) => {
          const liveData = doc.data();

          // 승인된 공연만 포함
          if (!liveData.approved) {
            return;
          }

          const lineup = liveData.lineup || [];
          // LinkookLiveTiles와 동일한 방식으로 날짜 파싱
          let liveDate = null;
          if (liveData.date) {
            if (liveData.date.seconds) {
              // Firestore Timestamp 객체인 경우
              liveDate = new Date(liveData.date.seconds * 1000);
            } else if (liveData.date.toDate) {
              // toDate 메서드가 있는 경우
              liveDate = liveData.date.toDate();
            } else if (liveData.date instanceof Date) {
              // 이미 Date 객체인 경우
              liveDate = liveData.date;
            } else {
              // 일반 날짜 문자열인 경우 (LinkookLiveTiles 방식)
              const parseDate = (dateStr) => {
                const tempDateStr = dateStr.replace(/\./g, "-").trim(); // 점(.)을 대시(-)로 변경
                const formattedDateStr = !tempDateStr.includes(":") // 시간이 없는 경우 기본값 " 00:00" 추가
                  ? tempDateStr + " 00:00"
                  : tempDateStr;
                return parse(formattedDateStr, "yyyy-MM-dd HH:mm", new Date());
              };

              const parsedDate = parseDate(liveData.date);
              if (isValid(parsedDate)) {
                liveDate = parsedDate;
              } else {
                liveDate = null;
              }
            }
          }

          lineup.forEach((performerName) => {
            // 직접 공연한 경우
            const count = artistLiveCount.get(performerName) || 0;
            artistLiveCount.set(performerName, count + 1);

            // 모든 공연 날짜 저장
            if (liveDate) {
              if (!artistPerformances.has(performerName)) {
                artistPerformances.set(performerName, []);
              }
              artistPerformances.get(performerName).push(liveDate);
            }

            // 밴드로 공연한 경우, 해당 밴드 멤버들에게도 공연 횟수 및 날짜 추가
            if (bandMemberMap.has(performerName)) {
              const memberIds = bandMemberMap.get(performerName);
              memberIds.forEach((memberId) => {
                // 멤버 ID를 이름으로 변환
                const memberName = artistIdToNameMap.get(memberId);
                if (memberName) {
                  const memberCount = artistLiveCount.get(memberName) || 0;
                  artistLiveCount.set(memberName, memberCount + 1);

                  // 멤버의 모든 공연 날짜도 저장
                  if (liveDate) {
                    if (!artistPerformances.has(memberName)) {
                      artistPerformances.set(memberName, []);
                    }
                    artistPerformances.get(memberName).push(liveDate);
                  }
                }
              });
            }
          });
        });

        // 각 아티스트별로 오늘 날짜와 가장 가까운 공연 찾기 (LinkookLiveTiles 방식)
        const artistClosestPerformance = new Map();
        const today = new Date();
        const todayMidnight = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate()
        );

        artistPerformances.forEach((dates, artistName) => {
          let closestDate = null;
          let minDistance = Infinity;

          dates.forEach((date) => {
            // 날짜 부분만 비교 (시간 제외) - LinkookLiveTiles 방식
            const getDateOnly = (date) => {
              return new Date(date.getFullYear(), date.getMonth(), date.getDate());
            };
            const dateOnly = getDateOnly(date);
            const distance = Math.abs(dateOnly.getTime() - todayMidnight.getTime());

            if (distance < minDistance) {
              minDistance = distance;
              closestDate = date;
            }
          });

          if (closestDate) {
            artistClosestPerformance.set(artistName, closestDate);
          }
        });

        const artistsData = [];

        // 이미지 URL 생성 없이 파일명만 저장
        artistsSnapshot.docs.forEach((doc) => {
          const artistData = doc.data();

          // 관리자가 아닌 경우 approved가 true인 것만 표시
          // 관리자인 경우 approved가 false인 것도 포함
          const shouldShow =
            artistData.approved || this.userStore.auth === "admin";

          if (!shouldShow) return;

          // myBands 필드에서 소속 밴드 ID 목록을 가져와 이름으로 변환
          const myBandsIds = artistData.myBands || artistData.MyBands || [];
          const affiliatedBands = myBandsIds
            .map(bandId => artistIdToNameMap.get(bandId))
            .filter(bandName => bandName); // 유효한 밴드명만

          artistsData.push({
            id: doc.id, // 문서 ID 추가
            slug: artistData.slug ?? null,
            name: artistData.name,
            detailLink: artistData.detailLink || null,
            profileImage: null, // 초기에는 null
            imgFileName: artistData.img || null, // 파일명 저장
            userProfileImg: artistData.userProfileImg || null, // 사용자 프로필 이미지 파일명
            userEmail: artistData.userEmail || null, // 사용자 이메일
            profileImageLoaded: false, // 이미지 로드 상태
            updatedAt: artistData.updatedAt || null,
            createdAt: artistData.createdAt || null, // 등록일시 추가
            type: artistData.type || null,
            liveCount: artistLiveCount.get(artistData.name) || 0, // 공연 횟수 추가
            likeCount: artistData.likedUsers?.length || 0, // 인기순 정렬용
            lastPerformanceDate:
              artistClosestPerformance.get(artistData.name) || null, // 가장 가까운 공연 날짜 추가
            affiliatedBands: affiliatedBands, // 소속 밴드 정보 추가
          });
        });

        // 공연 횟수 순으로 정렬 (많은 순)
        this.artists = artistsData.sort(
          (a, b) => (b.liveCount || 0) - (a.liveCount || 0)
        );

        // 첫 페이지 아티스트들의 프로필 이미지만 미리 로드
        await this.loadProfileImagesForCurrentPage();
      } catch (error) {
        console.error("아티스트 목록 조회 오류:", error);
        this.error = "아티스트 목록을 불러오는 중 오류가 발생했습니다.";
      } finally {
        this.loading = false;
      }
    },

    // 현재 페이지의 아티스트들만 프로필 이미지 로드
    async loadProfileImagesForCurrentPage() {
      const currentPageArtists = this.paginatedArtists;

      // 병렬로 이미지 URL 생성
      const imageLoadPromises = currentPageArtists
        .filter(
          (artist) =>
            (artist.imgFileName || artist.userProfileImg) &&
            !artist.profileImageLoaded
        )
        .map(async (artist) => {
          try {
            let imageRef;
            let imagePath;

            // 사용자 프로필 이미지가 있으면 profile 폴더에서, 아니면 artist 폴더에서 로드
            if (artist.userProfileImg) {
              imagePath = `profile/${artist.userProfileImg}`;
              imageRef = storageRef(storage, imagePath);
              // console.log(
              //   `사용자 프로필 이미지 로드 시도: ${artist.name} -> ${imagePath}`
              // );
            } else if (artist.imgFileName) {
              imagePath = `artist/${artist.imgFileName}`;
              imageRef = storageRef(storage, imagePath);
              // console.log(
              //   `아티스트 이미지 로드 시도: ${artist.name} -> ${imagePath}`
              // );
            }

            if (imageRef) {
              const profileImageUrl = await getDownloadURL(imageRef);
              artist.profileImage = profileImageUrl;
              artist.profileImageLoaded = true;
              // console.log(`프로필 이미지 로드 완료: ${artist.name}`);
            }
          } catch (error) {
            console.warn(
              `프로필 이미지 URL 생성 실패 (${artist.name}):`,
              error
            );
            artist.profileImage = null;
            artist.profileImageLoaded = true; // 실패해도 로드 시도했음을 표시
          }
        });

      await Promise.all(imageLoadPromises);
    },

    isArtistLiked(artistId) {
      return this.userArtistLikes.includes(artistId);
    },

    isMyArtist(artist) {
      if (!this.userStore.isLogin || !this.userStore.email) {
        return false;
      }
      return artist.userEmail === this.userStore.email;
    },

    async toggleArtistLike(artistId) {
      if (!this.userStore.isLogin) {
        this.userStore.showLoginPopup('artistLike');
        return;
      }

      try {
        this.likeLoading = true;

        const isCurrentlyLiked = this.isArtistLiked(artistId);

        const newLikedState = await toggleArtistLike(
          artistId,
          this.userStore.email,
          isCurrentlyLiked
        );

        // 로컬 상태 업데이트
        if (newLikedState) {
          // 찜 추가
          this.userArtistLikes.push(artistId);

          // 아티스트에게 알림 전송
          const artist = this.artists.find(a => a.id === artistId);
          if (artist?.userEmail && artist.userEmail !== this.userStore.email) {
            try {
              await createNotification({
                userId: artist.userEmail,
                type: "ARTIST_LIKE",
                title: "새로운 팬이 생겼어요! 💖",
                message: `${this.userStore.nickname || '누군가'}님이 ${artist.name}을(를) 찜했습니다.`,
                targetType: "artist",
                targetId: artistId,
                fromUserId: this.userStore.email,
                fromUserNickname: this.userStore.nickname || null,
              });
            } catch (notifError) {
              console.warn("알림 전송 실패:", notifError);
            }
          }
        } else {
          // 찜 해제
          this.userArtistLikes = this.userArtistLikes.filter(
            (id) => id !== artistId
          );
        }
      } catch (error) {
        console.error("아티스트 찜 오류:", error);
        this.$alert("오류가 발생했습니다. 다시 시도해주세요.");
      } finally {
        this.likeLoading = false;
      }
    },

    toggleType(type) {
      this.selectedTypes = createArtistListSelectedTypes(type);
    },

    toggleTypeDropdown() {
      this.showTypeDropdown = !this.showTypeDropdown;
    },

    selectTypeFromDropdown(key) {
      this.selectedTypes = createArtistListSelectedTypes(key);
      this.showTypeDropdown = false;
    },

    handleTypeDropdownClickOutside(event) {
      const el = this.$refs.typeDropdownContainer;
      if (el && !el.contains(event.target)) {
        this.showTypeDropdown = false;
      }
    },

    getActiveArtistListTypeKey(types) {
      return getActiveArtistListTypeKey(types);
    },

    scrollActiveTypeIntoView() {
      const key = getActiveArtistListTypeKey(this.selectedTypes);
      const scrollEl = this.$refs.typeFilterScroll;
      if (!scrollEl) return;
      const target = scrollEl.querySelector(`[data-type-key="${key}"]`);
      if (target) {
        target.scrollIntoView({ inline: "center", block: "nearest", behavior: "smooth" });
      }
    },

    toggleLikedFilter() {
      if (!this.userStore.isLogin) {
        this.userStore.showLoginPopup('likeFilter');
        return;
      }
      this.showLikedOnly = !this.showLikedOnly;
    },

    async goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        // 페이지 변경 후 이미지 로드는 watch에서 처리됨
      }
    },

    // 정렬 방식 토글 (5가지 순환)
    toggleSort() {
      const sortOptions = ["popular", "performance", "recent", "name", "registered"];
      const currentIndex = sortOptions.indexOf(this.sortBy);
      const nextIndex = (currentIndex + 1) % sortOptions.length;
      this.sortBy = sortOptions[nextIndex];
    },

    // 정렬 버튼 텍스트 반환
    getSortButtonText() {
      switch (this.sortBy) {
        case "performance":
          return "공연횟수";
        case "recent":
          return "가까운공연";
        case "popular":
          return "인기순";
        case "name":
          return "이름순";
        case "registered":
          return "등록순";
        default:
          return "가까운공연";
      }
    },

    formatDate(date) {
      if (!date) return "정보 없음";

      try {
        const dateObj = date instanceof Date ? date : new Date(date);
        if (isNaN(dateObj.getTime())) return "정보 없음";

        return dateObj.toLocaleDateString("ko-KR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        });
      } catch (error) {
        return "정보 없음";
      }
    },

    // 아티스트 등록 폼 관련 메서드
    async openArtistForm() {
      if (!this.userStore.isLogin) {
        this.userStore.showLoginPopup('artistRegister');
        return;
      }

      // 아티스트 등록 폼 열기
      this.showArtistForm = true;
      scrollManager.lock("artistForm");
    },

    // 아티스트 카드 모달 열기 (프로필의 아티스트 카드 설정과 동일)
    async openArtistCardModal() {
      if (!this.userStore.isLogin) {
        this.userStore.showLoginPopup('artistRegister');
        return;
      }

      // 트위터 연동 여부 확인
      if (!this.userDetailLink) {
        const confirmed = await this.$confirm(
          "아티스트 카드를 등록하려면 먼저 X(트위터) 계정 연동이 필요합니다.\n\n마이페이지로 이동하여 X 정보를 가져오시겠습니까?"
        );

        if (confirmed) {
          this.$router.push("/profile");
        }
        return;
      }

      // 트위터 연동이 되어 있으면 아티스트 카드 모달 열기
      this.artistCardModalVisible = true;
      scrollManager.lock("artistCardModal");
    },

    closeArtistForm() {
      this.showArtistForm = false;
      scrollManager.unlock("artistForm");
      // 폼이 닫힌 후 아티스트 목록을 새로고침할 수도 있음 (필요시)
      // this.fetchArtists();
    },

    closeArtistCardModal() {
      this.artistCardModalVisible = false;
      scrollManager.unlock("artistCardModal");
      this.fetchArtists(); // 모달 닫으면 목록 새로고침
    },

    async handleArtistCardUpdated() {
      // 아티스트 카드가 업데이트되었을 때 목록 다시 로드
      await this.fetchArtists();
    },

    async loadUserDetailLink() {
      if (!this.userStore.isLogin) {
        this.userDetailLink = null;
        return;
      }

      try {
        const { getUserDetailLink } = await import("@/utils/read/user");
        this.userDetailLink = await getUserDetailLink(this.userStore.email);
      } catch (error) {
        console.error("사용자 트위터 링크 로드 오류:", error);
        this.userDetailLink = null;
      }
    },
  },
};
</script>

<style module>
/* 배너 최소 높이 설정 */
.linkookLiveBanner {
  min-height: 150px;
}

.container {
  width: 90%;
  margin: 0 auto;
  padding: 0px 0px;
  font-family: "NanumSquareRoundR", sans-serif;
}

/* 광고 지면 */
.registerSection {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
}

.registerButton {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #66bdff;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-left: auto;
  font-family: "NanumSquareRoundB", sans-serif;
}

.registerButton:hover {
  background: #4a9eff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 189, 255, 0.3);
}

.plusIcon {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}

/* 데스크톱/모바일 표시 제어 */
.desktopOnly {
  display: none;
}

.mobileOnly {
  display: flex;
}

/* 모바일 플로팅 버튼 */
.floatingButton {
  position: fixed;
  right: calc(50% - 500px);
  max-width: 1024px;
  margin-right: 12px;
  height: 46px;
  padding: 0px 12px;
  border-radius: 30px;
  background: #66bdff;
  color: white;
  border: none;
  box-shadow: 0 4px 16px rgba(102, 189, 255, 0.4);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 199;
  font-size: 1rem;
  font-weight: bold;
  font-family: "NanumSquareRoundB", sans-serif !important;
  transition: all 0.3s ease;
  bottom: 80px;
}

@media screen and (max-width: 1024px) {
  .floatingButton {
    right: 12px;
  }
}

.floatingButton:hover {
  background: #4a9eff;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 189, 255, 0.6);
}

.floatingButton:active {
  transform: translateY(0);
}

.floatingIcon {
  width: 18px;
  height: 18px;
  filter: brightness(0) invert(1);
  flex-shrink: 0;
}

.header {
  text-align: center;
  margin-bottom: 30px;
}

.title {
  font-size: 2rem;
  font-weight: 400;
  color: #333;
  margin-bottom: 10px;
  font-family: "KccSign", "NanumSquareRoundB", sans-serif;
}

.subtitle {
  font-size: 1.1rem;
  color: #666;
  margin: 0;
}

/* 로딩 상태 */
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #66bdff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.error {
  text-align: center;
  color: #dc3545;
  margin: 20px 0;
}

.retryButton {
  background: #66bdff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
}

.retryButton:hover {
  background: #4a9eff;
}

.summary {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.summaryCard {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.summaryCard h3 {
  margin: 0 0 10px 0;
  color: #666;
  font-size: 1rem;
  font-weight: 500;
}

.summaryNumber {
  margin: 0;
  font-size: 2rem;
  font-weight: bold;
  color: #66bdff;
  font-family: "NanumSquareRoundB", sans-serif;
}

/* 필터 및 검색 컨트롤 */
.controls {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  padding: 10px;
}

.typeFilter {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
  min-width: 0;
}

.typeFilterScroll {
  display: flex;
  gap: 8px;
  align-items: center;
  overflow-x: auto;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.typeFilterScroll::-webkit-scrollbar {
  display: none;
}

/* 타입 필터 햄버거 드롭다운 */
.typeDropdown {
  position: relative;
  flex-shrink: 0;
}

.dropdownToggle {
  height: 34px;
  width: 34px;
  border-radius: 8px;
  background: white;
  border: 1px solid #ddd;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-family: "NanumSquareRoundR", sans-serif;
}

.dropdownToggle:hover {
  background: #f8f9fa;
  border-color: #cbd5e1;
}

.dehazeIcon {
  width: 22px;
  height: 22px;
  object-fit: contain;
  filter: brightness(0) invert(0.4);
  /* #666 */
}

.dropdownMenu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  min-width: 160px;
  max-height: 70vh;
  overflow-y: auto;
  animation: typeDropdownSlide 0.2s ease;
}

@keyframes typeDropdownSlide {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdownItem {
  width: 100%;
  padding: 10px 14px;
  background: white;
  border: none;
  text-align: left;
  font-size: 0.875rem;
  color: #64748b;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: "NanumSquareRoundR", sans-serif;
  border-bottom: 1px solid #f1f5f9;
}

.dropdownItem:last-child {
  border-bottom: none;
}

.dropdownItem:hover {
  background: #f8fafc;
  color: #334155;
}

.dropdownItem.activeDropdownItem {
  background: #1e293b;
  color: white;
  font-weight: bold;
}

.likeButton {
  padding: 5px 7px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.likeButton:hover {
  background: #f8f9fa;
  border-color: #ff6b9d;
}

.likeButton:active {
  background: #ff6b9d;
  border-color: #ff6b9d;
}

.activeLike {
  background: #ff6b9d;
  color: white;
  border-color: #ff6b9d;
}

.activeLike:hover {
  background: #ff6b9d;
  border-color: #ff6b9d;
}

.likeIcon {
  width: 20px;
  height: 20px;
  margin-top: 3px;
}

.typeButton {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundB", sans-serif;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.activeType {
  background: #66bdff;
  color: white;
  border-color: #66bdff;
}

.sortFilter {
  flex: 1;
  display: flex;
  gap: 8px;
  min-width: 200px;
  width: 100%;
}

.searchBox {
  flex: 1;
  min-width: 100px;
}

.searchInput {
  width: 100%;
  height: 34px !important;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundR", sans-serif;
  transition: border-color 0.2s ease;
}

.searchInput:focus {
  outline: none;
  border-color: #66bdff;
}

.filterBox {
  flex-shrink: 0;
}

.sortButton {
  padding: 8px 12px;
  background: #66bdff;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundB", sans-serif;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.sortButton:hover {
  background: #4a9eff;
}

.sortIcon {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}

.toggleSortButton {
  padding: 8px 12px;
  background: #66bdff;
  color: white;
  border: none;
  border-radius: 8px;
}

/* 찜 필터 스타일 (레거시 호환) */
.likeFilter {
  display: flex;
  align-items: center;
}

.sortSelect {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  font-family: "NanumSquareRoundR", sans-serif;
  background: white;
}

.adminNotice {
  margin-top: 30px;
  margin-bottom: 30px;
  font-size: 10px;
  color: #666;
  text-align: center;
}

.artistList {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 10px;
}

/* 빈 아티스트 카드 스타일 */
.emptyArtistCard {
  position: relative;
  padding: 15px;
  background: linear-gradient(135deg, #fff9e6 0%, #ffffff 100%);
  border-radius: 12px;
  border: 3px dashed #ffd700;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  min-height: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: emptyCardPulse 2s ease-in-out infinite;
}

.emptyArtistCard:hover {
  transform: translateY(-5px);
  border-style: solid;
  box-shadow: 0 8px 30px rgba(255, 215, 0, 0.4);
  background: linear-gradient(135deg, #fff5cc 0%, #fffef7 100%);
}

.emptyCardGlow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 50% 50%,
      rgba(255, 215, 0, 0.1) 0%,
      transparent 70%);
  pointer-events: none;
}

.emptyCardContent {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
}

.emptyProfileCircle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffd700 0%, #ffed4e 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);
  animation: emptyProfileBounce 2s ease-in-out infinite;
}

.plusIcon {
  font-size: 40px;
  color: white;
  font-weight: bold;
  line-height: 1;
  animation: emptyPlusRotate 3s ease-in-out infinite;
}

.emptyCardText {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.emptyCardTitle {
  margin: 0;
  font-size: 0.8rem;
  font-weight: bold;
  color: #333;
  font-family: "NanumSquareRoundB", sans-serif;
}

.emptyCardSubtitle {
  margin: 0;
  font-size: 0.5rem;
  color: #666;
  font-family: "NanumSquareRoundR", sans-serif;
  line-height: 1.4;
}

.emptyCardBadge {
  display: block;
  background: linear-gradient(135deg, #ffd700 0%, #ffed4e 100%);
  color: #333;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: bold;
  font-family: "NanumSquareRoundB", sans-serif;
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
  margin-top: 5px;
}

@keyframes emptyCardPulse {

  0%,
  100% {
    box-shadow: 0 2px 10px rgba(255, 215, 0, 0.2);
  }

  50% {
    box-shadow: 0 4px 20px rgba(255, 215, 0, 0.4);
  }
}

@keyframes emptyProfileBounce {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-5px);
  }
}

@keyframes emptyPlusRotate {

  0%,
  100% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(90deg);
  }

  50% {
    transform: rotate(180deg);
  }

  75% {
    transform: rotate(270deg);
  }
}

/* ArtistCard 관련 스타일들은 컴포넌트로 이동됨 */

/* 페이지네이션 스타일 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
  gap: 6px;
  flex-wrap: wrap;
}

.pageButton {
  padding: 6px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #ffffff;
  color: #666;
  font-size: 0.8125rem;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 32px;
  text-align: center;
}

.pageButton:hover:not(.activePage):not(:disabled) {
  background: #f8f9fa;
  border-color: #ccc;
  color: #333;
}

.pageButton:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  color: #ccc;
  background: #f8f9fa;
}

.activePage {
  background: #222;
  color: #ffffff;
  border-color: #222;
}

/* ==============================================
   반응형 디자인
   - Medium: 481px ~ (기본 스타일, 최대 1024px)
   - Small: ~480px
   ============================================== */

/* Small (~480px) - 모바일 */
@media screen and (max-width: 480px) {
  .linkookLiveBanner {
    min-height: 80px;
  }

  .container {
    padding: 0px;
  }

  .artistList {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 10px 0px;
  }

  /* 모바일 빈 아티스트 카드 */
  .emptyArtistCard {
    min-height: 100px;
    padding: 10px;
  }

  .emptyProfileCircle {
    width: 30px;
    height: 30px;
  }

  .plusIcon {
    font-size: 40px;
  }

  .emptyCardTitle {
    font-size: 1rem;
  }

  .emptyCardSubtitle {
    font-size: 0.6rem;
  }

  .emptyCardBadge {
    display: none;
    font-size: 0.7rem;
    padding: 3px 10px;
  }

  .title {
    font-size: 1.8rem;
  }

  .summary {
    grid-template-columns: 1fr;
  }

  /* 필터/검색 반응형 */
  .controls {
    gap: 8px;
    padding: 10px 0px;
  }

  .typeFilter {
    gap: 6px;
  }

  .typeFilterScroll {
    gap: 6px;
  }

  .dropdownToggle {
    height: 28px;
    width: 28px;
    border-radius: 6px;
  }

  .dehazeIcon {
    width: 18px;
    height: 18px;
  }

  .dropdownItem {
    padding: 10px 12px;
    font-size: 0.8125rem;
  }

  .typeButton {
    padding: 6px 12px;
    font-size: 0.75rem;
  }

  .activeType {
    background: #66bdff;
    color: white;
    border-color: #66bdff;
  }

  .likeButton {
    padding: 4px 6px;
  }

  .likeButton:active {
    background: #ff6b9d;
    border-color: #ff6b9d;
  }

  .likeIcon {
    width: 18px;
    height: 18px;
  }

  .searchInput {
    height: 31px !important;
    font-size: 0.75rem;
  }

  .sortButton {
    padding: 8px 10px;
    font-size: 0.75rem;
  }

  .sortButton:hover {
    background: #4a9eff;
  }

  .sortIcon {
    width: 14px;
    height: 14px;
  }

  /* 데스크톱 전용 버튼 숨김 */
  .desktopOnly {
    display: none !important;
  }

  .mobileOnly {
    display: flex;
  }

  .pagination {
    gap: 4px;
    margin-top: 18px;
  }

  .pageButton {
    padding: 5px 8px;
    font-size: 0.6875rem;
    min-width: 26px;
    border-radius: 5px;
  }
}
</style>
